import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faStar } from "@fortawesome/free-solid-svg-icons";

const SubscriptionHeader = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full px-5 py-8 space-y-2 text-center rounded-t-lg bg-gradient-to-r from-gray-50 via-slate-50 to-slate-100">
      <div className="px-3 py-1 text-xs font-medium text-amber-800 rounded-full shadow-sm bg-amber-100 shadow-yellow-200">
        Limited time offer before prices go up
      </div>
    </div>
  );
};

export default SubscriptionHeader;
